import { forwardRef, type Ref, type SVGProps } from "react";
const IconMonitorOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M28 4H4a2 2 0 0 0-2 2v15a2 2 0 0 0 2 2h9v3h-3a1 1 0 0 0 0 2h12a1 1 0 0 0 0-2h-3v-3h9a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2m0 2v11H4V6ZM4 21v-2h24v2Z"
    />
  </svg>
);
const ForwardRef = forwardRef(IconMonitorOutlineSVG);
ForwardRef.displayName = "IconMonitorOutline";
export { ForwardRef as IconMonitorOutline };
